import React, { useEffect, useState } from "react";
import Axios from "middleware/axiosInstance";
import { Link, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import moment from "jalali-moment";
import checkTik from "assets/images/wareHouse-icons/accept-check.svg";
import ButtonComponent from "components/Form/ButtonComponent";
import PrintDocumemtHeader from "components/printDocument/printDocumemtHeader/PrintDocumemtHeader";
import PrintDocumemtBody from "components/printDocument/printDocumemtBody/PrintDocumemtBody";
import PrintDocumemtFooter from "components/printDocument/printDocumemtFooter/PrintDocumemtFooter";

const WarehouseDocumentDetails = () => {
  // start react router url params
  const UrlParams = useParams();
  const docType = UrlParams.type === "entry" ? "import" : "export";
  console.log(docType);
  // end react router url params
  // return the location object to parse url with useLocation
  const { search } = useLocation();
  // get query string to get user info
  const UrlQueryString = queryString.parse(search);
  const docId = UrlQueryString.DocId;
  console.log(docId);
  const [docInfo, setDocInfo] = useState(null);

  const getDocInfo = () => {
    Axios.get(`/${docType}/${docId}`)
      .then((res) => {
        setDocInfo(res.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getDocInfo();
  }, []);

  return (
    <div className="customized-container ">
      <div className="customized-wrapper d-print-none">
        <h5 className="title-session d-print-none">
          {docType === "import" ? "سند ورود به انبار" : "سند خروج از انبار"}
        </h5>
        <div className="d-flex flex-column w-100 ">
          <div>
            {docInfo && (
              <>
                <div className="d-flex flex-row ">
                  <Link
                    to={`/warehouse/edit-warehouse-document/${docType === "import" ? "entry" : "exit"
                      }?DocId=${docId}`}
                  >
                    <ButtonComponent
                      value="ویرایش"
                      className="bi-custom-button"
                    />
                  </Link>

                  <ButtonComponent
                    value="پرینت"
                    onClick={window.print}
                    className="bi-custom-button"
                  />

                </div>

                <h5 className="me-3 mt-2">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt=""
                    srcset=""
                  />
                  سند و انبار
                </h5>
                <table className="bi-table-style w-100">
                  <thead>
                    <tr>
                      <th>شماره سند</th>
                      <th>شماره عطف</th>
                      <th>تاریخ سند</th>
                      <th>ساعت سند</th>
                      <th>نوع سند</th>
                      <th>نام انبار</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{docInfo.sh_sanad || "- - -"}</td>
                      <td>{docInfo.sh_atf || "- - -"}</td>
                      <td>
                        {
                          // (docInfo.date
                          //  &&
                          //   moment(docInfo.date, "YYYY/MM/DD")
                          //     .locale("fa")
                          //     .format("YYYY/MM/DD"))
                          docInfo.date || "- - -"}
                      </td>
                      <td>{docInfo.time || "- - -"}</td>
                      <td>{docInfo.is_trust ? "امانی" : "قطعی" || "- - -"}</td>
                      <td>{docInfo.anbar.name || "- - -"}</td>
                    </tr>
                  </tbody>
                </table>
                <h5 className="me-3 mt-4">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt=""
                    srcset=""
                  />
                  اشخاص و ارز
                </h5>
                <table className="bi-table-style w-100">
                  <thead>
                    <tr>
                      <th>نام شخص اول</th>
                      <th>عنوان شخص اول</th>
                      <th>نام شخص دوم</th>
                      <th>ارز</th>
                      <th>نرخ ارز</th>

                      {/* <th>ارزش افزوده</th>
                      <th>محاسبه ارزش افزوده در قیمت</th>
                      <th>نوع بارکد</th>
                      <th>شماره بارکد</th>
                      <th>قیمت فروش</th>
                      <th>قیمت خرید</th>
                      <th>نقطه سفارش</th>
                      <th>مقدار سفارش</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {`${docInfo.people.name} ${docInfo.people.family}` || "- - -"}
                      </td>
                      <td>{docInfo.people_label || "- - -"}</td>
                      <td>
                        {docInfo.second_people?.name ? `${docInfo.second_people?.name} ${docInfo.second_people?.family}` : "- - -"}
                      </td>
                      <td>{docInfo.arz === "rial" ? "ریال" : docInfo.arz}</td>
                      <td>{docInfo.nerkh_arz || "- - -"}</td>
                    </tr>
                  </tbody>
                </table>

                {docInfo.description && (
                  <>
                    <h5 className="me-3 mt-4 ">
                      <img
                        width={25}
                        src={checkTik}
                        className="ms-1"
                        alt=""
                        srcset=""
                      />
                      توضیحات
                    </h5>
                    <table className="bi-table-style w-100">
                      <thead>
                        <tr>
                          <th>توضیحات</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{docInfo.description || "توضیحات ندارد"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}

                <h5 className="me-3 mt-4">
                  <img
                    width={25}
                    src={checkTik}
                    className="ms-1"
                    alt=""
                    srcset=""
                  />
                  اقلام سند
                </h5>

                <table className="bi-table-style w-100">
                  <thead>
                    <tr>
                      <th>ردیف</th>
                      <th>شناسه کالا</th>
                      <th>نام کالا</th>
                      <th>مقدار</th>
                      <th>مقدار باقی مانده پس از این سند</th>
                      <th>توضیحات</th>
                    </tr>
                  </thead>
                  <tbody>
                    {docInfo.items.map((item, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.commodity_id}</td>
                          <td>{docType === "import" ? item.commodity.name : item.second_commodity.name}</td>
                          <td>{docType === "import" ? item.count_im : item.count_ex}</td>
                          <td>{item.current_count}</td>
                          <td>{item.description}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </div>
      {
        docInfo && docType ?
          <div className="d-print-flex d-none flex-column">
            <PrintDocumemtHeader docInfo={docInfo} docType={docType} />
            <PrintDocumemtBody docInfo={docInfo} docType={docType} />
            <PrintDocumemtFooter />
          </div>
          : null
      }
    </div>
  );
};
export default WarehouseDocumentDetails;